<template>
  <div>
    <div class="title mt-5">
      <h3 class="d-flex justify-content-center header">
        {{$t('headers.questionnaire')}}
      </h3>
    </div>
    <div class="content">
      <fade-transition :duration="200" mode="out-in">
        <question
          v-if="currentQuestionIndex !== undefined"
          :key="currentQuestionIndex"
          :question="currentQuestion"
          :selectedAnswer="form.data.answers[currentQuestionIndex]"
          @answerSelected="onAnswerSelected">
        </question>
      </fade-transition>
      <div class="d-flex justify-content-center mt-5 mb-5">
        <span
          class="pagination-dot"
          v-for="page in questionnaire.questions.length"
          :key="page - 1"
          :class="{'active': page - 1  === currentQuestionIndex}"
          >
        </span>
      </div>
      <div class="actions d-flex" :class="{'justify-content-between': currentQuestionIndex > 0, 'justify-content-end': currentQuestionIndex === 0}">
        <button v-if="currentQuestionIndex > 0" class="button primary" @click="previousAction">{{ previousActionText }}</button>
        <button class="button primary"
            :class="{'disabled': form.data.answers[currentQuestionIndex] === undefined}"
            @click="nextAction">{{ nextActionText }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import FadeTransition from '@/vue-components/Utils/FadeTransition.vue'
import Question from './Question.vue'

export default {
  props: {
    questionnaire: {
      type: Object,
      required: true
    },
    answers: {
      type: Array,
      required: true
    },
    initialQuestionIndex: {
      type: Number,
      required: false,
      default: 0
    }
  },
  components: {
    Question,
    FadeTransition
  },
  mounted: function () {
    this.form.data.answers = JSON.parse(JSON.stringify(this.answers))
    this.currentQuestionIndex = this.initialQuestionIndex
  },
  computed: {
    previousActionText: function () {
      return this.currentQuestionIndex === 0 ? this.$t('actions.back') : this.$t('actions.previous_question')
    },
    nextActionText: function () {
      return this.currentQuestionIndex === this.questionnaire.questions.length - 1 ? this.$t('actions.next') : this.$t('actions.next_question')
    },
    currentQuestion: function () {
      return this.questionnaire.questions[this.currentQuestionIndex]
    }
  },
  data: function () {
    return {
      currentQuestionIndex: undefined,
      form: {
        data: {
          answers: []
        }
      }
    }
  },
  methods: {
    previousAction: function () {
      if (this.currentQuestionIndex === 0) {
        this.$emit('back')
      } else {
        this.currentQuestionIndex --
      }
    },
    nextAction: function () {
      if (this.form.data.answers[this.currentQuestionIndex] !== undefined) {

        if (this.currentQuestionIndex === this.questionnaire.questions.length - 1) {
          this.$emit('continue')
        } else (
          this.currentQuestionIndex ++
        )
      }
    },
    onAnswerSelected: function (answer) {
      this.form.data.answers[this.currentQuestionIndex] = answer
      this.$forceUpdate()

      // this.$ga.event({
      //   eventCategory: 'questionnaire-answer',
      //   eventAction: this.currentQuestion.text,
      //   eventLabel: answer.text,
      //   eventValue: answer.id
      // })

      this.nextAction()
      // setTimeout(() => {
      //   this.nextAction()
      // }, 250)
    }
  },
  watch: {
    'form.data.answers': function (value) {
      this.$emit('update:answers', this.form.data.answers)
    }
  }
}
</script>